class RouterHelper {
    public parseParamToInt(param: string, defaultValue: number | null = Number.MIN_SAFE_INTEGER): number | null {
        const value = parseInt(param, 10);
        if (isNaN(value)) {
            return defaultValue;
        }
        return value;
    }
}

export const routerHelper = new RouterHelper();
